module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/ogp-bc72ffc72f3b505ad370603483c6ba95.png";